/*
  Purito – sample seçimi ve ödeme öncesi otomatik tamamlama
  1) Sepetteki sample kartlarına tıklayınca sample eklenir / çıkarılır.
  2) "Ödemeye geç" tıklandığında sepet dengelenir:
     - hak = ücretli ürün adedi, en fazla config.max
     - eksik sample varsa stoğu en yüksek olanlardan eklenir (_sample: otomatik)
     - fazla sample varsa son eklenenlerden başlayarak çıkarılır
     Bir hata olursa müşteri engellenmez, ödemeye devam edilir.
*/
(function () {
  if (window.__puritoSamplesInit) return;
  window.__puritoSamplesInit = true;

  var routes = (window.Shopify && window.Shopify.routes) || {};
  var root = routes.root || '/';
  var cartPath = routes.cart || root + 'cart';

  function cartSections() {
    return window.location.pathname === cartPath
      ? ['cart-drawer', 'cart-desktop', 'cart-mobile']
      : ['cart-drawer'];
  }

  function readConfig() {
    var el = document.querySelector('[data-purito-samples-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  async function postJSON(url, body) {
    var res = await fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) throw new Error(data.description || data.message || 'request_failed');
    return data;
  }

  async function getCart() {
    var res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async function refreshCart(sections) {
    try {
      var cart = await getCart();
      var counter = document.querySelector('[data-cart-count]');
      if (counter) counter.setAttribute('data-cart-count', cart.item_count);
      var viewport = document.querySelector('.layout--viewport');
      if (viewport) viewport.setAttribute('data-cart-empty', cart.item_count === 0);
    } catch (e) {}

    var keys = Object.keys(sections || {});
    if (!keys.length) { window.location.reload(); return; }
    keys.forEach(function (id) {
      if (!sections[id]) return;
      window.dispatchEvent(new CustomEvent('theme:cart:' + id.replace(/^cart-/, '') + ':updateHtml', {
        detail: { section: sections[id], load_transitions: false }
      }));
    });
  }

  /* ---------- Kartlarla seçim ---------- */
  async function toggleSample(card) {
    var block = card.closest('.purito-samples');
    var cards = block ? block.querySelectorAll('.purito-samples__card') : [card];
    cards.forEach(function (c) { c.setAttribute('aria-busy', c === card ? 'true' : 'false'); c.dataset.wasDisabled = c.disabled ? '1' : ''; c.disabled = true; });

    try {
      var data;
      var keys = (card.getAttribute('data-sample-keys') || '').split(',').filter(Boolean);
      if (keys.length) {
        var updates = {};
        keys.forEach(function (k) { updates[k] = 0; });
        data = await postJSON('cart/update.js', { updates: updates, sections: cartSections() });
      } else {
        data = await postJSON('cart/add.js', {
          items: [{ id: parseInt(card.getAttribute('data-sample-variant'), 10), quantity: 1, properties: { _sample: 'secim' } }],
          sections: cartSections()
        });
      }
      await refreshCart(data.sections);
    } catch (err) {
      cards.forEach(function (c) { c.removeAttribute('aria-busy'); c.disabled = c.dataset.wasDisabled === '1'; });
      var el = block && block.querySelector('.purito-samples__error');
      if (el) { el.textContent = 'Sample güncellenemedi, lütfen tekrar deneyin.'; el.hidden = false; }
    }
  }

  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-sample-variant]');
    if (card && !card.disabled) {
      event.preventDefault();
      toggleSample(card);
    }
  });

  /* ---------- Ödeme öncesi dengeleme ---------- */
  async function normalizeCart(config) {
    var cart = await getCart();
    var sampleIds = {};
    config.variants.forEach(function (v) { sampleIds[v.id] = v; });

    var eligible = 0;
    var sampleLines = [];
    cart.items.forEach(function (item) {
      if (sampleIds[item.variant_id]) {
        sampleLines.push(item);
      } else if (item.final_line_price > 0 && !(item.properties && item.properties._kampanya)) {
        eligible += item.quantity;
      }
    });

    var entitlement = Math.min(eligible, config.max || 3);
    var selected = sampleLines.reduce(function (s, l) { return s + l.quantity; }, 0);

    if (selected > entitlement) {
      // Fazlaları sondan başlayarak çıkar
      var excess = selected - entitlement;
      var updates = {};
      for (var i = sampleLines.length - 1; i >= 0 && excess > 0; i--) {
        var line = sampleLines[i];
        var cut = Math.min(line.quantity, excess);
        updates[line.key] = line.quantity - cut;
        excess -= cut;
      }
      await postJSON('cart/update.js', { updates: updates });
    } else if (selected < entitlement) {
      // Eksikleri stoğu en yüksek sample'lardan tamamla (önce sepette olmayanlar, çeşit olsun)
      var missing = entitlement - selected;
      var inCart = {};
      sampleLines.forEach(function (l) { inCart[l.variant_id] = (inCart[l.variant_id] || 0) + l.quantity; });

      var pool = config.variants
        .filter(function (v) { return v.available && v.stock > 0; })
        .sort(function (a, b) { return b.stock - a.stock; });

      var fresh = pool.filter(function (v) { return !inCart[v.id]; });
      var ordered = fresh.concat(pool.filter(function (v) { return inCart[v.id]; }));
      var left = {};
      ordered.forEach(function (v) { left[v.id] = v.stock - (inCart[v.id] || 0); });

      var picks = [];
      var guard = 0;
      while (picks.length < missing && ordered.length && guard < (missing + 1) * ordered.length) {
        var v = ordered[guard % ordered.length];
        if (left[v.id] > 0) { picks.push(v.id); left[v.id]--; }
        guard++;
      }

      if (picks.length) {
        var grouped = {};
        picks.forEach(function (id) { grouped[id] = (grouped[id] || 0) + 1; });
        await postJSON('cart/add.js', {
          items: Object.keys(grouped).map(function (id) {
            return { id: parseInt(id, 10), quantity: grouped[id], properties: { _sample: 'otomatik' } };
          })
        });
      }
    }
  }

  /* ---------- Sepet her güncellendiğinde: hak düştüyse fazla tester'ı hemen çıkar ---------- */
  var trimTimer = null;
  var trimming = false;

  async function trimExcess() {
    var config = readConfig();
    if (!config || !config.variants || !config.variants.length || trimming) return;
    trimming = true;
    try {
      var cart = await getCart();
      var sampleIds = {};
      config.variants.forEach(function (v) { sampleIds[v.id] = true; });
      var eligible = 0;
      var sampleLines = [];
      cart.items.forEach(function (item) {
        if (sampleIds[item.variant_id]) sampleLines.push(item);
        else if (item.final_line_price > 0 && !(item.properties && item.properties._kampanya)) eligible += item.quantity;
      });
      var entitlement = Math.min(eligible, config.max || 3);
      var selected = sampleLines.reduce(function (s, l) { return s + l.quantity; }, 0);
      if (selected <= entitlement) return;

      var excess = selected - entitlement;
      var updates = {};
      for (var i = sampleLines.length - 1; i >= 0 && excess > 0; i--) {
        var cut = Math.min(sampleLines[i].quantity, excess);
        updates[sampleLines[i].key] = sampleLines[i].quantity - cut;
        excess -= cut;
      }
      var data = await postJSON('cart/update.js', { updates: updates, sections: cartSections() });
      await refreshCart(data.sections);
    } catch (e) {
      // sessizce geç; ödeme öncesi kontrol yine çalışır
    } finally {
      trimming = false;
    }
  }

  window.addEventListener('theme:cart:updated', function () {
    clearTimeout(trimTimer);
    trimTimer = setTimeout(trimExcess, 150);
  });

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('.cart--form')) return;
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    var config = readConfig();
    if (!config || !config.variants || !config.variants.length) return; // sistem kapalı: tema normal devam eder

    event.preventDefault();
    try {
      await normalizeCart(config);
    } catch (e) {
      // Sample işlemi başarısız olsa da satış engellenmez
    }
    window.location.href = root + 'checkout';
  }, true);
})();